import Splide from '@splidejs/splide';
import { DESKTOP_WIDTH, TABLET_WIDTH } from '../constants/devices.constants';
let ambassadorCarousel = null;
let testimonialCarousel = null;
export function getAmbassadorCarousel() {
    return ambassadorCarousel;
}
const testimonialCarouselOptions = {
    type: 'loop',
    perPage: 1,
    arrows: true,
    pagination: false,
};
const ambassadorCarouselOptions = {
    type: 'slide',
    perPage: 1,
    arrows: true,
    pagination: false,
    drag: true,
    rewind: false,
    mediaQuery: 'min',
    breakpoints: {
        [TABLET_WIDTH]: {
            drag: false,
        },
        [DESKTOP_WIDTH]: {
            arrows: false,
            drag: false,
            loop: false,
            rewind: true,
            speed: 0,
        },
    },
};
export default {
    init() {
        const testimonialEl = document.querySelector('.testimonial-slider .splide');
        const ambassadorEl = document.querySelector('.js-ambassador-slider');
        if (testimonialEl) {
            testimonialCarousel = new Splide(testimonialEl, testimonialCarouselOptions);
            testimonialCarousel.mount();
        }
        if (ambassadorEl) {
            ambassadorCarousel = new Splide(ambassadorEl, ambassadorCarouselOptions);
            ambassadorCarousel.mount();
        }
    },
};
